import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import TokenService from '../services/storage.service'

//import Jobs from '../views/JobsListing.vue'
import Job from '../views/JobSingle.vue'
import JobMain from  '../views/JobMain.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    },
    beforeEnter(to, from, next) {
      const loggedIn = !!TokenService.getToken()

      if (!loggedIn) {
        next()
      } else {
        next({ path: '/' + TokenService.getToken() })
      }
    }
  },
  {
    path: '/:token',
    name: 'Job',
    component: Job,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crmcustomer/job/get',
      title: 'Job',
      key: 'job'
    }
  },
  {
    path: '/job/main/:id',
    name: 'JobMain',
    component: JobMain,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'crmcustomer/jobs/get',
      title: 'Job',
      key: 'job'
    }
  },
]

const router = new VueRouter({
  routes
})

export default router
